import React, { useRef, useState } from "react";
import { images } from "../../Images/Svg";
import style from "./VendorUpload.module.css";
import { truncateMiddleText } from "../../Utils/helper";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import CustomSelectAccordion from "../Select/CustomSelectAccordion";
import CustomSelect from "../Select/CustomSelect";
import { ArrowDropDown } from "@mui/icons-material";
const { DownloadUp } = images;

const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: "#ebeef8",
      borderRadius: "0 0 4px 4px",
    },
  },
};

const dropdownStyles = {
  fontSize: "1.5rem",
  ".MuiSvgIcon-root ": {
    fontSize: "4rem",
    color: "#7C7C7C",
  },
  ".makeStyles-placeholder-1": {
    color: "#5E6366",
  },
  ".MuiPopover-root.MuiMenu-paper.Mui-focused": {
    borderRadius: "4px 4px 0 0",
  },
};

const VendorUpload = ({
  onChangeHandler = () => {},
  name = "",
  label = "",
  placeholder = "Select",
  header = "",
  headerStyle = {},
  uploadedImg = false,
  viewImg = false,
  uploadedDocuments = {},
  required = false,
  onlyIcon = false,
  options = [],
  value = null,
  truncateSize = 10,
  textIconGap = "1rem",
  onSelect = () => {},
  disabled = false,
}) => {
  const [isModalOpen, setIsModalOPen] = useState(false);
  const fileInputRef = useRef(null);
  const isUploaded =
    uploadedDocuments?.hasOwnProperty(label) &&
    uploadedDocuments[label]?.filename?.length > 0;
  const handleClick = () => {
    fileInputRef?.current?.click();
  };

  const onOpenModalHandler = () => {
    setIsModalOPen(true);
  };

  return (
    <>
      <p
        style={{
          display: header ? header : "none",
          marginBottom: "1rem",
          color: "#3a3a3a",
          fontSize: "1.25rem",
          fontWeight: 500,
          ...headerStyle,
        }}
      >
        {header + " "}
        {required ? <span style={{ color: "red" }}>*</span> : ""}
      </p>
      {onlyIcon ? (
        <div className={style["select_container"]}>
          <CustomSelect
            name={name}
            afterSx={{
              ...dropdownStyles,
              background: value ? "white" : "#ebeef8",
              width: "15rem",
              border: `1px solid ${value ? "#5570F1" : "#ebeef8"}`,
            }}
            labelStyles={{ marginBottom: "0" }}
            placeholder={placeholder}
            customSelectValue={value}
            options={options}
            handleChange={onSelect}
            dropDownIcon={ArrowDropDown}
            menuProps={menuProps}
          />

          <div
            className={
              isUploaded ? style["file_uploaded_vm"] : style["file_uploader_vm"]
            }
          >
            {isUploaded ? (
              <>
                {uploadedImg && (
                  <img
                    height="10px"
                    width="15px"
                    src={uploadedDocuments[label]?.fileUrl}
                    alt={label}
                    onClick={handleClick}
                  />
                )}
                <p
                  style={{ fontSize: "1.2rem", fontWeight: "400" }}
                  onClick={handleClick}
                >
                  {truncateMiddleText(
                    uploadedDocuments[label]?.filename,
                    truncateSize
                  )}
                </p>
                {viewImg && (
                  <p className={style["view_btn"]} onClick={onOpenModalHandler}>
                    View
                  </p>
                )}
              </>
            ) : (
              ""
            )}
            <img
              src={DownloadUp}
              height={10}
              alt="Download Icon"
              onClick={handleClick}
            />
            <input
              accept=".png, .jpg, .jpeg, .heic, .heif, .webp"
              type="file"
              name={name}
              onClick={(e) => (e.target.value = null)}
              onInput={onChangeHandler}
              style={{
                display: "none",
              }}
              ref={fileInputRef}
              disabled={disabled}
            />
          </div>
        </div>
      ) : (
        <div
          className={
            isUploaded ? style["file_uploaded_vm"] : style["file_uploader_vm"]
          }
          style={{ gap: textIconGap }}
        >
          {isUploaded && uploadedImg ? (
            <img
              height="10px"
              width="15px"
              src={uploadedDocuments[label]?.fileUrl}
              alt={label}
            />
          ) : (
            ""
          )}
          <p
            style={{ fontSize: "1.2rem", fontWeight: "400" }}
            onClick={handleClick}
          >
            {isUploaded
              ? truncateMiddleText(
                  uploadedDocuments[label]?.filename,
                  truncateSize
                )
              : label}
          </p>
          {isUploaded && viewImg ? (
            <p className={style["view_btn"]} onClick={onOpenModalHandler}>
              View
            </p>
          ) : (
            ""
          )}
          <img src={DownloadUp} alt="Download Icon" onClick={handleClick} />
          <input
            accept=".png, .jpg, .jpeg, .heic, .heif, .webp"
            type="file"
            name={name}
            onClick={(e) => (e.target.value = null)}
            onInput={onChangeHandler}
            style={{
              display: "none",
            }}
            ref={fileInputRef}
          />
        </div>
      )}
      <CommonModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOPen(false);
        }}
        width="60%"
        height="60%"
      >
        <img
          width="100%"
          height="100%"
          src={uploadedDocuments[label]?.fileUrl}
          alt={uploadedDocuments[label]?.fileUrl}
        />
      </CommonModal>
    </>
  );
};

export default VendorUpload;
